module.exports = __webpack_public_path__ + "img/tutorial_img_4_1.38300121.png";